import React, { useEffect } from 'react';
import queryString from 'query-string';
import { adobDatasheetLog, adobProductLog } from '../../utils/analytics/adobe/adob';
import * as adob from '../../utils/analytics/adobe/adob';
import { LinearProgress } from '@mui/material';
import Box from '@material-ui/core/Box';
import { useStyles } from './styles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import { localDownloadLog, localProductLog } from '../../utils/analytics/local';

const LinkRedirect = () => {
	const classes = useStyles();
	const { t } = useTranslation();
	useEffect(() => {
		const trackingParameters = queryString.parse(window.location.search);
		const redirectLink = trackingParameters.redirectLink;

		const isValidRedirect = url => {
			// Check if the URL starts with http:// or https://
			return /^(https?:\/\/)/.test(url);
		};

		const logEvents = () => {
			if (trackingParameters.logEventType === adob.logEventType.DATASHEETLOG) {
				Promise.allSettled([adobDatasheetLog(trackingParameters), localDownloadLog(trackingParameters)]).then(() =>
					setTimeout(() => {
						redirect();
					}, 150)
				);
			} else if (trackingParameters.logEventType === adob.logEventType.PRODUCTLOG) {
				Promise.allSettled([adobProductLog(trackingParameters), localProductLog(trackingParameters)]).then(() =>
					setTimeout(() => {
						redirect();
					}, 150)
				);
			}
		};

		const redirect = () => {
			if (redirectLink && isValidRedirect(redirectLink)) {
				window.location.replace(redirectLink);
			} else {
				// Handle invalid URLs: Redirect to a default page or show an error message
				console.error('Invalid redirect URL');
			}
		};

		logEvents();

		setTimeout(() => {
			redirect();
		}, 4000);
	}, []);

	return (
		<div>
			<Box sx={{ width: '100%' }} className={classes.progressbar}>
				<LinearProgress />
			</Box>

			<Grid container direction="column" alignItems="center">
				<Grid item className={classes.title}>
					<Typography variant="h4">{t('pages.redirect.messages.datasheetRedirect.title')}</Typography>
				</Grid>
			</Grid>
		</div>
	);
};

export default LinkRedirect;
